<div class="wrapper">
  @if (fileErrors) {
  <div>
    <p class="fix-errors">Please fix the errors and try again</p>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Errors description</mat-panel-title>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="fileErrors">
        <ng-container matColumnDef="row">
          <th mat-header-cell *matHeaderCellDef>Row</th>
          <td mat-cell *matCellDef="let element">{{element.row}}</td>
        </ng-container>
        <ng-container matColumnDef="errors">
          <th mat-header-cell *matHeaderCellDef>Errors</th>
          <td mat-cell *matCellDef="let element">
            @for (error of element.errors; track $index) {
            <p>{{error}}</p>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </mat-expansion-panel>
  </div>
  } @if (!successfulUploaded) {
  <div class="import">
    {{ 'ADMIN.DEVICES.ASSIGN_FILE_TO_IMPORT' | translate }} :&nbsp; @if (fileInput.files[0]) {
    <ng-container>[{{ fileInput.files[0].name }}]&nbsp;</ng-container>
    }
    <a (click)="fileInput.click()">{{ 'FUEL.UPLOAD' | translate }}</a>
  </div>
  }
  <input #fileInput type="file" hidden />
  @if (isUploading) {
  <lin-spinner></lin-spinner>
  } @if (successfulUploaded) {
  <div class="success">
    <p>Device assignments succefully uploaded</p>
    <button mat-raised-button color="accent" (click)="close()">{{ 'BUTTONS.OK' | translate }}</button>
  </div>
  }
</div>
